import { jsx as _jsx } from "react/jsx-runtime";
import { FlexBox } from '@dixa/lib-shared-habla';
import { channelAttributes } from 'utils/channels';
import { useConversationRow } from '../../../utils/useConversationRow';
/** Represents the content of the channel cell in the conversations table. */
export const ConversationsTableChannel = () => {
    const { conversationAndRequester: { conversation }, } = useConversationRow();
    return (_jsx(FlexBox, Object.assign({ alignItems: "center" }, { children: channelAttributes[conversation.initial_channel].name })));
};
